"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var IconBase_1 = __importDefault(require("../IconBase"));
var util_1 = require("../util");
var Fire = function (props) {
    var primary = (0, util_1.getVariantClassNames)(props).primary;
    return (react_1.default.createElement(IconBase_1.default, __assign({}, props),
        react_1.default.createElement("path", { d: "M23.3333 11.6667C22.75 17.25 21.0833 20.1667 18.3333 20.5834C18.3333 20.5834 20.8333 10.8334 17.5 5.83337C17.5 5.83337 17.1667 11.1667 13.5833 17.5834C11.9167 20.5834 10 22.6667 10 26.6667C10 32.4167 15.8333 35.3334 20 35.3334C24.1667 35.3334 30 33.3334 30 26.3334C30 23.4167 27.75 18.5834 23.3333 11.6667Z", className: primary })));
};
exports.default = Fire;
